<template>
    <div> 
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header>
         <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Mi Tarjeta MasterCard
            </b-card-header>
            <b-card-body>
                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <label>¡Listo!</label> 
                    </div>
                </div>  
                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <label>Tu solicitud ha sido aprobada</label> 
                    </div>
                </div>   
                <div class="text-center" style="margin-top: 10px">
                    <img src="@/assets/card_landing.png" class="mx-auto d-block" width="40%" height="40%" />
                </div>
                <div class="row form-group" >
                    <div class="col-md-12 text-center">
                        <save-button text="¿Donde esta mi tarjeta?" @click="dondeEstaMiTarjeta"></save-button>
                    </div>
                </div>
            </b-card-body>
        </b-card> 
    </div>
</template>

<style>
</style>

<script>
    import Vue from 'vue'
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    import 'vue-select/dist/vue-select.css';
    import axiosHelpers from '@/helpers/axiosHelpers';
    import notificationHelpers from '@/helpers/notificationHelpers';

    export default {
        components: { 
        },
        data(){
            return{
                model: {                  
                },
            }
        },
        methods: {
            dondeEstaMiTarjeta() {
                let context = this
                context.$router.push({ name: "ApprovedCardTracking", params: { welcomeMessage: "Aprobada" , requestState: context.$store.getters.MastercardSolicitudAlta }});
            }
        }
    }
</script>